import React, {useState} from 'react'
import _ from 'lodash'

const Selection = props => {
    const data = props.data;

    const [optionClicked, setOptionClicked] = useState(data.options.map(()=>false));
    const [isInitial, setIsInitial] = useState(data.options.map(()=>true));
    const [lastChanged, setLastChanged] = useState(-1);



    const onSubmitButtonClick = () => {
        if(optionClicked.filter(el=>el).length === 0) return;
        props.onComplete(optionClicked)
        //send temp value to outro pager thing
    }

    const handleOptionClick = (optionIndex) => {
        let temp = _.clone(optionClicked)
        temp[optionIndex] = !temp[optionIndex];
        setOptionClicked(temp);

        let temp2 = _.clone(isInitial)
        temp2[optionIndex] = false;
        setIsInitial(temp);

        setLastChanged(optionIndex)
    }

    const resetLastChanged = () => {
        setLastChanged(-1)
    }
    return (
        <div className="Selection">
                      <div className="top-half">
                {/* header */}
                <h1 className={`header`} dangerouslySetInnerHTML={{ __html: data.selection.header }}></h1>
    
                {/* instructions */}
                <div className={`instructions`} dangerouslySetInnerHTML={{ __html: data.selection.instructions }}></div>
          </div>

            <div className={'bottom-half'}>
            <div className={`body`} dangerouslySetInnerHTML={{ __html: data.selection.body }}></div>
                {/* options */}
                {
                    data.options &&
                    <div className={'options'}>
                        {
                            data.options.map((option, optionIndex) => {
                                return <div 
                                className={`option ${lastChanged === optionIndex ? 'recent' : 'not-recent'} ${isInitial[optionIndex] ? 'initial' : 'not-initial'} ${optionClicked[optionIndex] ? 'selected' : 'not-selected'}`} 
                                key={`option-${optionIndex}`}
                                onMouseLeave={resetLastChanged}
                                onClick={()=>handleOptionClick(optionIndex)}
                                dangerouslySetInnerHTML={{ __html: option }}></div>
                            })
                        }
                    </div>
                }
    
                {/* submit button */}
                <div id={'submit-button'} className={`global-button submit ${optionClicked.filter(el=>el).length > 0 ? 'enabled' : 'disabled'}`} onClick={onSubmitButtonClick}>Submit</div>
            </div>
        </div>
    )
}

export default Selection